<template lang="html">
  <Card :style="{ width: isMobile ? '300px' : '434px' }">
    <CardHeader title="Portfolio Distribution" slot="title"></CardHeader>
    <Row type="flex" justify="center" align="middle" class="feature-card">
      <PortfolioDist style="height: 100%; width: 100%;"></PortfolioDist>
    </Row>
  </Card>
</template>

<script>
import PortfolioDist from './charts/PortfolioDist';
import CardHeader from './CardHeader';

export default {
  props: ['isMobile'],
  components: { PortfolioDist, CardHeader },
};
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/PortfolioDistCard.vue